export default __webpack_public_path__ + "static/media/ElainaBiechler.bfab7723.jpg";